// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"logo-facebook"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M18 1H14C11.2386 1 9 3.23858 9 6V9.5H5.25V14H9V23H14V14H17L18 9.5H14V6.5C14 5.94772 14.4477 5.5 15 5.5H18V1Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M18 1H14C11.2386 1 9 3.23858 9 6V9.5H5.25V14H9V23H14V14H17L18 9.5H14V6.5C14 5.94772 14.4477 5.5 15 5.5H18V1Z","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-logo-facebook')
export default class LogoFacebookIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-facebook',
    }
  }
}
